<template>
<div class="mask">
    <div class="camera-box">
        <div class="close" @click="close">X</div>
        <el-row :gutter="20">
            <el-col :span="24">
                <div style="text-align: center;font-size: 14px;font-weight: bold;margin-bottom: 10px;">请将脸对准摄像头，开始识别记录</div>
                <!-- 这里就是摄像头显示的画面 -->
                <video id="video" width="600" height="400"></video>
                <div class="iCenter">
                    <el-button type='primary' size='small' icon="el-icon-camera" @click="takePhone" style="margin-top: 10px;">完成</el-button>
                </div>
            </el-col>
            <!-- 这里是点击拍照显示的图片画面 -->
            <!-- <el-col :span="12">
            
            </el-col> -->
            <div style="display:none">
                <div style="text-align: center;font-size: 14px;font-weight: bold;margin-bottom: 10px;">拍摄效果</div>
                <canvas id='canvas' width='400' height='300' style="display: block;"></canvas>
                <el-button :loading="loadingbut" icon="el-icon-check" type='primary' size='small' @click="takePhoneUpfile" style="margin-top: 10px;">保存</el-button>
            </div>
        </el-row>
    </div>
</div>
</template>

<script>
//   import {putFileAttach} from "@/api/customer/animalinfo";
export default {
    props: {
        tackPhoto: { //父组件传过来的状态
            type: Boolean,
            default: false
        },
        faceSet: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loadingbut: false,
            preViewVisible: false,
            blobFile: null,
            canvas: null,
            video: null,
            mediaStreamTrack: '',
        }
    },
    watch: {
        tackPhoto: {
            immediate: true,
            handler(newVal) { //监听接收到拍摄状态后，开始调取摄像头权限。如果功能是在一个组件里面，下面步骤可以直接写在自己的触发方法里面
                if (newVal) {
                    var video = document.querySelector('video');
                    var text = document.getElementById('text');
                    // var mediaStreamTrack;

                    // 兼容代码
                    window.URL = (window.URL || window.webkitURL || window.mozURL || window.msURL);

                    if (navigator.mediaDevices === undefined) {
                        navigator.mediaDevices = {};
                    }
                    if (navigator.mediaDevices.getUserMedia === undefined) {
                        navigator.mediaDevices.getUserMedia = function (constraints) {
                            var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
                            if (!getUserMedia) {
                                return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
                            }
                            return new Promise(function (resolve, reject) {
                                getUserMedia.call(navigator, constraints, resolve, reject);
                            });
                        }
                    }

                    //摄像头调用配置
                    var mediaOpts = {
                        audio: false,
                        video: true,
                        video: {
                            facingMode: "environment"
                        } // 或者 "user"
                        // video: { width: 1280, height: 720 }
                        // video: { facingMode: { exact: "environment" } }// 或者 "user"
                    }

                    let that = this;
                    navigator.mediaDevices.getUserMedia(mediaOpts).then(function (stream) {
                        that.mediaStreamTrack = stream;
                        video = document.querySelector('video');
                        if ("srcObject" in video) {
                            video.srcObject = stream
                        } else {
                            video.src = window.URL && window.URL.createObjectURL(stream) || stream
                        }
                        video.play();
                    }).catch(function (err) {
                        console.log(err)
                    });

                }
            },
            deep: true
        },
    },
    mounted() {
        // 摄像头
        this.video = document.getElementById('video');
        //画布
        this.canvas = document.getElementById('canvas')

    },
    methods: {
        close() {
            this.mediaStreamTrack.getTracks()[0].stop();
            this.$emit('closeCamera')
        },
        takePhone() { //点击拍照截图画面
            let that = this;
            that.canvas.getContext('2d').drawImage(this.video, 0, 0, 400, 300);
            let dataurl = that.canvas.toDataURL('image/jpeg')
            // that.blobFile = that.dataURLtoFile(dataurl, 'camera.jpg');
            that.blobFile = dataurl;
            console.log(dataurl)
            that.preViewVisible = true;
            if (this.faceSet) {
                this.close();
                this.$emit('uplodFaceImg', dataurl)
            } else {
                this.$axios.post("/user/loginByFace", {
                    faceImgStr: dataurl
                }).then(res => {
                    console.log(res)
                    if (res.data.code == 0) {
                        this.close();
                        this.$message.success('人脸识别完成，成功登录');
                        var infos = res.data.data;
                        that.$store.commit("TOKEN_INIT", {
                            token: infos.token
                        });
                        localStorage.setItem('userinfos', JSON.stringify(infos));
                        if (infos.token) {
                            localStorage.setItem('token', infos.token)
                            this.AppUtils.setCookie("token", infos.token);
                            that.$store.commit("ONLINE_STATUS", infos.onlineStatus);
                        }
                        if (infos.activeSeat) {
                            this.$router.push('/workPlat');
                        } else {
                            this.$router.push('/hall');
                        }
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(err => {
                    throw err;
                })
            }
        },
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(',')
            var mime = arr[0].match(/:(.*?);/)[1]
            var bstr = atob(arr[1])
            var n = bstr.length
            var u8arr = new Uint8Array(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new File([u8arr], filename, {
                type: mime
            })
        },
        takePhoneUpfile() { //保存图片
            this.loadingbut = true;
            let formData = new FormData()
            console.log('this.blobFile', this.blobFile)
            // formData.append('file', this.blobFile); //图片内容
            // 上传图片
            // putFileAttach(formData).then(res=>{//后台接口
            //   this.loadingbut=false;
            //   this.$emit('picture',res.data.data);
            //   this.tackPhoto=false;
            //   this.canvas.getContext('2d').clearRect(0, 0, 400, 300);//清除画布
            //   // 关闭摄像头
            //   this.mediaStreamTrack.getVideoTracks().forEach(function (track) {
            //     track.stop();
            //    });
            // },error=>{
            //   this.loadingbut=false;
            //   window.console.log(error);
            // });
        },
    }
}
</script>

<style lang="scss" scoped>
.mask {
    width: 100%;
    position: absolute;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);

    // left:50%;
    // top: 50%;
    // transform: translate(-30%,-50%);
    .camera-box {
        // width: 900px;
        box-sizing: border-box;
        padding: 20px 0px;
        background: #fff;
        position: relative;

        .close {
            position: absolute;
            top: 10px;
            right: 10px;
            cursor: pointer;
        }

        #canvas {
            border: 1px solid #DCDFE6;
        }
    }
}
</style>



// WEBPACK FOOTER //
// camera.vue?0da76a1e